import { IsEnabledOnGridBaseValueConverter } from 'General/Resources/ValueConverters/IsEnabledOnGridBase';

export class IsEnabledOnGridValueConverter extends IsEnabledOnGridBaseValueConverter {

}